// This is the place where supported locales are defined. This is then used by
// both the ui and the translationRunner tooling to create/update the extracted messages.
export const defaultLocaleCode = 'en-AU' as const;
export const otherLocales = ['en-US'] as const;

export const supportedLocales = [defaultLocaleCode, ...otherLocales] as const;
export type SupportedLocales = typeof supportedLocales[number];
